export default {
    ssl_steps: {
        csr_and_domain: {
            label: 'CSR & Domain',
            title: 'បញ្ចូល CSR & domains {packageName} នឹងគ្របដណ្តប់',
            subtitle:
                'ជំហាន {step}។ បញ្ចូល CSR ដែលបង្កើតដោយផ្អែកលើព័ត៌មានក្រុមហ៊ុនរបស់អ្នក និងដែនដែលអ្នកជាម្ចាស់។',
        },
        select_dcv_method: {
            label: 'ជ្រើសរើសវិធីសាស្ត្រ DCV',
            title: 'បញ្ជាក់ថាអ្នកជាម្ចាស់ដែន',
            subtitle: 'ជំហាន {step}។ ជ្រើសរើសវិធីផ្ទៀងផ្ទាត់ការគ្រប់គ្រងដែន។',
        },
        admin_email: {
            label: 'អ៊ីមែលអ្នកគ្រប់គ្រង',
            title: 'ទំនាក់ទំនង {packageName}',
            subtitle: 'ជំហាន {step}។ បញ្ជាក់ថាតើយើងគួរផ្ញើឯកសារ SSL ទៅអ្នកណា',
        },
        review_and_submit: {
            label: 'ពិនិត្យ និងបញ្ជូន',
            title: 'ពិនិត្យ និងបញ្ជូន',
            subtitle: 'ជំហាន {step} ។ សូមពិនិត្យមើលព័ត៌មាន SSL ខាងក្រោម',
        },
    },
    title: 'វិញ្ញាបនបត្រ SSL',
    ssl_certificates: 'វិញ្ញាបនបត្រ SSL',
    certificate_id: 'លេខសម្គាល់',
    package_name: 'ឈ្មោះ',
    num_years: 'បានទិញសម្រាប់',
    expired_date: 'កាលបរិច្ឆេទផុតកំណត់',
    auto_renew: 'បន្តដោយស្វ័យប្រវត្តិ',
    status: 'ស្ថានភាព',
    info: {
        activate_it: 'បើកដំណើរការវា',
        install_it: 'ដំឡើងវា',
        validation_process: 'validation process',
        installation_guides: 'ការណែនាំអំពីការដំឡើង',
        issued_a_year: 'ចេញសម្រាប់ 1 ឆ្នាំ',
        new_hint:
            'ដើម្បីប្រើ SSL ដំបូងអ្នកត្រូវ {activateIt} ហើយបន្ទាប់មក {installIt}',
        pending_hint: 'បំពេញ {validationProcess}',
        active_hint:
            'SSL របស់អ្នក បានចេញរួចរាល់ សម្រាប់ការតម្លើង។ {lineBreak}សូមពិនិត្យមើល {installationGuides} របស់យើងសម្រាប់ប្រភេទម៉ាស៊ីនមេដែលប្រើញឹកញាប់បំផុត។',
        active_more_hint:
            'SSL របស់អ្នក ត្រូវបាន {issuedAYear} និងរួចរាល់សម្រាប់ការដំឡើង។ {lineBreak}ពិនិត្យ {installationGuides} របស់ពួកយើងសម្រាប់ប្រភេទម៉ាស៊ីនមេដែលប្រើជាទូទៅបំផុត។',
        renewal_hint:
            'ដើម្បីបន្ត SSL ដំបូងអ្នកត្រូវ {activateIt} ហើយបន្ទាប់មក {installIt}',
        pauses_on: 'ផ្អាកនៅថ្ងៃ {pausesDate}',
    },
    active_step_csr: {
        hint: 'ការប្រើប្រាស់ CSR ដែលមានស្រាប់សម្រាប់ការបន្ត SSL អាចបង្កើតការគំរាមកំហែងផ្នែកសុវត្ថិភាព ដូច្នេះយើងណែនាំអ្នកឱ្យទទួលបាន CSR ថ្មីរាល់ពេល។{lineBreak}អ្នកអាចឃើញអ្វីជា CSR និងរបៀបបង្កើតវាដោយចុចលើប៊ូតុង "អានបន្ថែម"។',
        enter_csr: 'បញ្ចូល CSR',
        enter_csr_placeholder: 'បញ្ចូល CSR នៅទីនេះ',
        primary_domain: 'ដែនបឋម',
        primary_domain_placeholder: 'យើងនឹងបន្ថែមវាពី CSR',
        additional_domains: 'បន្ថែមដែនបន្ថែមទៀត',
        additional_domains_placeholder: 'example.com',
    },
    active_ssl_title: 'SSL សកម្ម',
    ssl_certificate_detail: 'ព័ត៌មានលម្អិតអំពីវិញ្ញាបនបត្រ SSL',
    active_step_dcv: {
        title: 'កែសម្រួលវិធីសាស្ត្រ DCV សម្រាប់ {packageName}',
        hint: 'អ្នកអាចមើលរបៀបបំពេញ DCV ដោយចុចលើប៊ូតុង "អានបន្ថែម"។',
        dcv_method: 'វិធីសាស្រ្ត DCV',
        approver_email: 'អ៊ីមែលអនុម័ត',
        hints: {
            dns: 'អ្នកនឹងត្រូវបង្កើតកំណត់ត្រា CNAME តាមរយៈទំព័រ host records, cPanel ឬអ្នកផ្តល់ DNS ។',
            http: 'អ្នកនឹងត្រូវទាញយកឯកសារមួយហើយបន្ទាប់មកផ្ទុកវាទៅថតឫសរបស់ដែនរបស់អ្នក។',
            email: 'អាជ្ញាធរ​វិញ្ញាបនបត្រ​នឹង​ផ្ញើ​អ៊ីមែល​បញ្ជាក់​សុពលភាព (កន្លែង​ណា​ដែល​អាច​អនុវត្ត​បាន) ហើយ​អ្នក​នឹង​ត្រូវ​ចុច​លើ​តំណ​ដែល​បាន​បញ្ចូល​ដើម្បី​បំពេញ DCV ។',
        },
        same_dcv: 'DCV ដូចគ្នាសម្រាប់ដែនទាំងអស់។',
    },
    active_step_admin_email: {
        company: {
            title: 'ក្រុមហ៊ុន',
            form: {
                company_name: {
                    label: 'ឈ្មោះ​ក្រុម​ហ៊ុន',
                    placeholder: 'Legal name',
                },
                company_business: {
                    label: 'Doing business as',
                    placeholder:
                        'ប្រសិនបើអ្នកដំណើរការក្រោមឈ្មោះផ្សេង (ជាជម្រើស)',
                },
                company_registration_number: {
                    label: 'លេខចុះឈ្មោះ',
                    placeholder: 'ជួយឱ្យ {validationType} លឿនជាងមុន (ជាជម្រើស)',
                },
            },
        },
        legal_address: {
            title: 'អាស័យដ្ឋានស្របច្បាប់',
            form: {
                country_state: {
                    label: 'ប្រទេស និងរដ្ឋ',
                    state_placeholder: 'ខេត្ត/រដ្ឋ',
                },
                city_zip: {
                    label: 'ទីក្រុង និងលេខកូដប្រៃសណីយ៍',
                    city_placeholder: 'ទីក្រុង',
                    zip_placeholder: 'បញ្ចូលហ្ស៊ីប/ប្រៃសណីយ៍',
                },
                address: {
                    label: 'អាស័យដ្ឋាន',
                    placeholder: 'បញ្ចូលអាសយដ្ឋាន',
                },
            },
        },
        representative: {
            title: 'តំណាង',
            form: {
                full_name: {
                    label: 'ឈ្មោះ​ពេញ',
                    first_name_placeholder: 'ឈ្មោះដំបូង',
                    last_name_placeholder: 'នាមត្រកូល',
                },
                job_title: {
                    label: 'ចំណងជើងការងារ',
                    placeholder:
                        'ត្រូវតែជាអ្នកគ្រប់គ្រងប្រភេទណាមួយ (CEO, VP, ល)',
                },
                phone_number: {
                    label: 'លេខទូរសព្ទ',
                },
                their_email: {
                    label: 'អ៊ីមែលរបស់ពួកគេ',
                },
            },
        },
        ssl_will_be_sent_to: {
            title: 'SSL នឹងត្រូវបានបញ្ជូនទៅ',
            form: {
                admin_email: {
                    label: 'អ៊ីមែលអ្នកគ្រប់គ្រង',
                },
            },
        },
    },
    ssl_validation_types: {
        dv: 'ដែន (DV)',
        dv_full: 'សុពលភាពដែន (DV)',
        ov: 'អង្គការ (OV)',
        ov_full: 'សុពលភាពអង្គការ (OV)',
        ev: 'បន្ថែម (EV)',
        ev_full: 'សុពលភាពបន្ថែម (EV)',
    },
    active_step_review: {
        hint: 'អ្នកនឹងទទួលបានការណែនាំអំពីរបៀបបញ្ចប់សុពលភាពនៃការគ្រប់គ្រងដែន (DCV) នៅជំហានបន្ទាប់។ នៅពេលអ្នកបំពេញ DCV អាជ្ញាធរវិញ្ញាបនបត្រនឹងពិនិត្យសំណើរបស់អ្នក និងចេញ SSL យោងតាមព័ត៌មានដែលបានដាក់ជូន។',
        company: 'ក្រុមហ៊ុន',
        company_name: 'ឈ្មោះ​ក្រុម​ហ៊ុន',
        doing_business_as: 'Doing business as',
        registration_number: 'លេខចុះឈ្មោះ',
        legal_address: 'អាសយដ្ឋានស្របច្បាប់',
        country_state: 'ប្រទេស និងរដ្ឋ',
        city_zip_code: 'ទីក្រុង និងលេខកូដតំបន់',
        address: 'អាស័យដ្ឋាន',
        representative: 'តំណាង',
        full_name: 'ឈ្មោះ​ពេញ',
        job_title: 'ចំណងជើងការងារ',
        phone_number: 'លេខទូរសព្ទ',
        their_email: 'អ៊ីមែលរបស់ពួកគេ',
        will_sent_to: 'SSL នឹងត្រូវបានបញ្ជូនទៅ',
        admin_email: 'អ៊ីមែលអ្នកគ្រប់គ្រង',
        domain_dcv: 'ដែនធានា និងវិធីសាស្ត្រ DCV',
        domain_dcv_hints: {
            dns: 'បង្កើតកំណត់ត្រា CNAME',
            http: 'បង្ហោះឯកសារបញ្ជាក់សុពលភាពទៅកាន់ {domain}{fileFolder}',
            email: 'ទទួលបានអ៊ីមែលនៅ {email}',
        },
    },
    lifetime_limit_modal: {
        title: 'ដែនកំណត់អាយុកាល SSL',
        confirm_title:
            'SSLs ទាំងអស់ដែលបានទិញសម្រាប់{lineBreak}យូរជាង 1 ឆ្នាំ ឬក្រោយនេះ។',
        confirm_description:
            'SSL នឹងត្រូវចេញផ្សាយឡើងវិញជារៀងរាល់ឆ្នាំ ដើម្បីជៀសវាងការរំខានសេវាកម្ម។ យើង​នឹង​ផ្ញើ​ការ​រំលឹក​តាម​អ៊ីមែល​ជា​ច្រើន​ចាប់​ពី​ថ្ងៃ 30 ថ្ងៃ​មុន​ពេល​ផុត​កំណត់​របស់ SSL 1 ឆ្នាំ។',
    },
    reissue_ssl_title: 'ចេញ SSL ឡើងវិញ',
    extend: {
        title: 'ពង្រីក SSL',
        package: 'កញ្ចប់ SSL',
        package_name: 'ឈ្មោះកញ្ចប់',
        additional_domains: 'ដែនបន្ថែម',
        domains: 'ដែន',
    },
    ssl_detail: {
        guides: {
            dns_validation: {
                title: 'សុពលភាព DNS៖ របៀបទទួលបានកំណត់ត្រា DNS',
                content:
                    'DNS លំនាំដើមរបស់ 1Byte, បម្រុងទុក DNS ឬ FreeDNS៖ ចូលទៅកាន់ទំព័រកំណត់ត្រាម៉ាស៊ីន។{lineBreak}1Byte Hosting DNS៖ បង្កើតកំណត់ត្រា CNAME ដោយដៃនៅក្នុងគណនី cPanel របស់អ្នក។{lineBreak}ផ្សេងទៀត៖ បង្កើតកំណត់ត្រា CNAME ដោយដៃនៅឯក្រុមហ៊ុនផ្តល់ DNS របស់អ្នក។',
            },
            dns_record: {
                title: 'ការណែនាំ៖ កំណត់ត្រា DNS ត្រូវបានបន្ថែមយ៉ាងត្រឹមត្រូវ',
                content:
                    'ដូចដែលអ្នកបានបន្ថែម CNAME ទៅកាន់តំបន់ DNS នៃដែនរបស់អ្នក សូមពិនិត្យមើលថាតើ CNAME ត្រូវបានបន្ថែមត្រឹមត្រូវដែរឬទេ៖{lineBreak}ចូលទៅកាន់ {cnameLookupUrl}.{lineBreak}បញ្ចូលតម្លៃ CNAME ហើយចុច “CNAME lookup”។ ប្រសិនបើអ្នកទទួលបាន "កំណត់ត្រា DNS ដែលបានបោះពុម្ពផ្សាយ" ទាំងអស់គឺត្រឹមត្រូវ។',
            },
            http_validation: {
                title: 'សុពលភាព HTTP៖ បង្ហោះឯកសារបញ្ជាក់',
                get_records: 'ឯកសារពីទំព័រនេះ (វិធីសាស្ត្រកែសម្រួល)',
                content:
                    'បង្កើតថតឯកសារ “.well-known” និង “pki-validation” នៅដែនសុវត្ថិភាពនីមួយៗ{fileFolder} ហើយបង្ហោះសុពលភាព {getRecords}។{lineBreak}អ្នកគួរតែអាចចូលប្រើឯកសារពី៖ {accessFileUrl}{lineBreak}{fileName} ត្រូវតែអាចចូលប្រើបានពីគ្រប់ URL',
            },
            email_validation: {
                title: 'សុពលភាពអ៊ីមែល៖ របៀបផ្ញើអ៊ីមែលអ្នកយល់ព្រមឡើងវិញ',
                change_validation_method:
                    'ផ្លាស់ប្តូរវិធីសាស្ត្រផ្ទៀងផ្ទាត់ (កែសម្រួលវិធីសាស្ត្រ)',
                these_emails: 'អ៊ីមែលទាំងនេះ',
                content:
                    'អ៊ីមែលដែលមានតំណផ្ទៀងផ្ទាត់នឹងត្រូវបានផ្ញើទៅ {approverEmails} ក្នុងពេលឆាប់ៗនេះ។ មានតែបញ្ជីអាសយដ្ឋានអ៊ីមែលដែលបានកំណត់ជាមុនដែលទាក់ទងនឹងឈ្មោះដែនរបស់អ្នកប៉ុណ្ណោះដែលអាចត្រូវបានប្រើដើម្បីឆ្លងកាត់សុពលភាពនៃការគ្រប់គ្រងដែន។ ប្រសិនបើអ្នកមិនមានសិទ្ធិចូលប្រើ {theseEmails}, {changeValidationMethod} ។',
            },
        },
        additional_info: {
            admin_details: 'ព័ត៌មានលំអិតរបស់អ្នកគ្រប់គ្រង',
            secures: 'ធានា',
            validation_method: 'វិធីសាស្ត្រផ្ទៀងផ្ទាត់',
            approver_email: 'អ៊ីមែលអនុម័ត',
            company: 'ក្រុមហ៊ុន',
            legal_address: 'អាស័យដ្ឋានស្របច្បាប់',
            representative: 'តំណាង',
            admin_email: 'អ៊ីមែលអ្នកគ្រប់គ្រង',
        },
        csr_info: {
            server_type: 'ប្រភេទម៉ាស៊ីនមេ',
            server_type_hint:
                'បង្ហាញពីប្រភេទនៃម៉ាស៊ីនមេ ដែលវិញ្ញាបនបត្រដែលបានចេញនឹងត្រូវគ្នាជាមួយ។',
            server_type_content: 'Apache, Nginx, cPanel ឬផ្សេងទៀត',
            hashing_algorithm: 'ក្បួនដោះស្រាយ Hashing',
            hashing_algorithm_hint:
                'ការពារប្រឆាំងនឹងការក្លែងបន្លំវិញ្ញាបនបត្រ។',
            hashing_algorithm_content: 'SHA-2',
            methods_in_use: 'វិធីសាស្រ្តក្នុងការប្រើប្រាស់',
            csr_code: 'កូដ CSR',
        },
        general_info: {
            status: 'ស្ថានភាព',
            pending_status_hint:
                'ឥឡូវនេះ 1Byte កំពុងពិនិត្យមើលស្ថានភាពសម្រាប់វិញ្ញាបនបត្រនេះ។ សូមរង់ចាំពីរ ទៅ បីនាទី សម្រាប់ការធ្វើបច្ចុប្បន្នភាព',
            expired_date: 'កាលបរិច្ឆេទផុតកំណត់',
            activation_date: 'កាលបរិច្ឆេទធ្វើឱ្យសកម្ម',
            issued_for: 'ចេញសម្រាប់',
            issued_for_hint:
                'សុពលភាពអតិបរមា SSL ដែលមិនតម្រូវឱ្យមានការចេញសារជាថ្មី។',
            pauses: 'ផ្អាក',
            pauses_hint:
                'សូមចេញសារជាថ្មីមុនកាលបរិច្ឆេទនេះ ដើម្បីជៀសវាងការរំខានសេវាកម្ម។',
            purchased_for: 'បានទិញសម្រាប់',
            type: 'ប្រភេទ',
            domains: 'ដែន',
            ssl_id: 'លេខសម្គាល់ SSL',
            order_id: 'លេខ​សម្គាល់​លំដាប់',
            ca_order_id: 'លេខសម្គាល់ការបញ្ជាទិញ CA',
            ca_order_id_hint:
                'អំពីលេខសម្គាល់ការបញ្ជាទិញ CA សូម {clickHere} សម្រាប់ព័ត៌មានលម្អិតបន្ថែម',
        },
    },
    ssl_alert: {
        ready: {
            title: 'SSL របស់អ្នកត្រូវបានចេញ ហើយរួចរាល់សម្រាប់ការដំឡើង',
            description:
                'សូមពិនិត្យមើលការណែនាំអំពីការដំឡើងរបស់យើងសម្រាប់ប្រភេទម៉ាស៊ីនមេដែលប្រើជាទូទៅបំផុត។ គេហទំព័ររបស់អ្នកនឹងត្រូវបានធានារហូតដល់ {expireDate}។ ដើម្បីរក្សាការតភ្ជាប់ដែលមានសុវត្ថិភាពបន្ទាប់ពីកាលបរិច្ឆេទនេះ អ្នកនឹងត្រូវទិញ SSL បន្តថ្មី ហើយដំឡើងវា។ យើងនឹងផ្ញើការរំលឹកនៅពេលវាដល់ពេល។ អ្នកអាចឃើញការណែនាំអំពីការដំឡើងដោយចុចលើប៊ូតុង "អានបន្ថែម"។',
            installation_guides: 'ការណែនាំអំពីការដំឡើង',
            ssl_lifetime_limit: 'ដែនកំណត់អាយុកាល SSL',
            title_more_sans:
                'SSL របស់អ្នកត្រូវបានចេញក្នុងរយៈពេល 1 ឆ្នាំ​ និងរួចរាល់សម្រាប់ការដំឡើង',
            description_more_sans:
                'សូមពិនិត្យមើល {installationGuides} របស់យើង សម្រាប់ប្រភេទម៉ាស៊ីនមេដែលប្រើញឹកញាប់បំផុត។ គេហទំព័ររបស់អ្នកនឹងត្រូវបានធានារហូតដល់ {expireDate}។ ដើម្បីរក្សាការតភ្ជាប់ដែលមានសុវត្ថិភាពបន្ទាប់ពីកាលបរិច្ឆេទនេះ អ្នកនឹងត្រូវចេញសារជាថ្មីនិងដំឡើង SSL របស់អ្នកឡើងវិញ ដើម្បីអនុលោមតាមឧស្សាហកម្ម {SSLLifetimeLimit} ។ ពួកយើងនឹងផ្ញើការរំលឹកដល់អ្នក នៅពេលវេលាមកដល់។',
        },
        ready_active: {
            title: 'ចាប់ផ្តើមជាមួយ SSL ថ្មី',
            description:
                'ដើម្បីប្រើ SSL ដំបូងអ្នកត្រូវធ្វើឱ្យវាសកម្មហើយបន្ទាប់មកដំឡើងវានៅលើម៉ាស៊ីនមេរបស់អ្នក។ ដើម្បីដំណើរការ SSL របស់អ្នក {submitData} ទៅអាជ្ញាធរវិញ្ញាបនបត្រ និង {confirmControl} ដែនដែលអ្នកចង់ធានា។',
            submit_data: 'ដាក់បញ្ជូនទិន្នន័យរបស់អ្នក',
            confirm_control: 'បញ្ជាក់ថាអ្នកគ្រប់គ្រង',
        },
    },
    qty: 'បរិមាណ',
    buy_more_domains_alert:
        'ការទិញដែនបន្ថែមមិនផ្លាស់ប្តូរកាលបរិច្ឆេទផុតកំណត់ SSL ទេ។ ប្រសិនបើដែនបន្ថែមរបស់អ្នកត្រូវបានបន្ថែម 30 ថ្ងៃមុនពេលផុតកំណត់ SSL ពួកគេនឹងត្រូវបានធានាសម្រាប់តែ 30 ថ្ងៃប៉ុណ្ណោះ។',
    revoke: {
        title: 'ដកហូត',
        warning_title: 'SSL នឹងត្រូវបានលុបចោល',
        warning_content:
            'នៅពេលដែលអ្នកដក SSL អ្នកនឹងមិនអាចប្រើវានៅលើគេហទំព័ររបស់អ្នកបានទេ។',
    },
    csr_decode: {
        modal_title: 'កូដ CSR',
        title: '{name} ការបកប្រែកូដ CSR',
        subtitle:
            'ពិនិត្យមើលកំណែដែលបានឌិកូដនៃ CSR របស់អ្នក ដើម្បីផ្ទៀងផ្ទាត់ថាព័ត៌មានដែលវាមានគឺត្រឹមត្រូវ។ CSR (សំណើចុះហត្ថលេខាលើវិញ្ញាបនបត្រ) គឺជាកូដដែលបង្កើតដោយភាគីខាងម៉ាស៊ីនមេ ឬដោយភាគីទីបី។ វាត្រូវបានទាមទារសម្រាប់ការធ្វើឱ្យសកម្ម SSL ។ {contactSupport} ប្រសិនបើអ្នកមានការព្រួយបារម្ភអំពី CSR របស់អ្នក។',
        contact_support: 'ទាក់ទងផ្នែកជំនួយ',
        primary_domain: 'ដែនចម្បង',
        server_type: 'ប្រភេទម៉ាស៊ីនមេ',
        server_type_hint:
            'បង្ហាញពីប្រភេទនៃម៉ាស៊ីនមេ ដែលវិញ្ញាបនបត្រដែលបានចេញនឹងត្រូវគ្នាជាមួយ។',
        hashing: 'ក្បួនដោះស្រាយ Hashing',
        hashing_hint: 'ការពារប្រឆាំងនឹងការក្លែងបន្លំវិញ្ញាបនបត្រ។',
        email: 'អ៊ីមែល',
        company: 'ក្រុមហ៊ុន',
        department: 'នាយកដ្ឋាន',
        location: 'ទីតាំង',
    },
    csr_decode_type: {
        domain: 'ដែន',
        locality: 'មូលដ្ឋាន',
        state: 'រដ្ឋ',
        organization: 'អង្គការ',
        organization_unit: 'អង្គភាព',
        email: 'អ៊ីមែល',
        country: 'ប្រទេស',
        basic_constraints: 'មូលដ្ឋានឧបសគ្គ',
        key_usage: 'គន្លឹះនៃការប្រើប្រាស់',
        ext_key_usage: 'គន្លឹះនៃការបន្ដការប្រើប្រាស់',
        subject_alt_name: 'DNS Subject Alt Names',
    },
    related_title: 'វិញ្ញាបនបត្រ SSL ដែលពាក់ព័ន្ធ',
    dcv_download: {
        modal_title: 'ទាញ​យក​ឯកសារ',
        title: 'ទាញយកឯកសារសម្រាប់សុពលភាពត្រួតពិនិត្យដែន',
        subtitle:
            'ដើម្បីបញ្ចប់នីតិវិធី DCV៖ ទាញយកឯកសារ បន្ទាប់មកបង្កើតផ្លូវខាងក្រោមសម្រាប់ domain(s)/subdomain(s) វិញ្ញាបនបត្ររបស់អ្នកកំពុងត្រូវបានធ្វើឱ្យសកម្ម: {fileFolder} ហើយបង្ហោះវានៅទីនោះ។ កុំកែសម្រួលឈ្មោះ ឬខ្លឹមសាររបស់ឯកសារ។ វិធីសាស្រ្ត DCV (Domain Control Validation) គឺជាវិធីនៃការបង្ហាញថាអ្នកជាម្ចាស់ ឬគ្រប់គ្រងឈ្មោះដែនដែលបានចុះឈ្មោះជាក់លាក់មួយ។ មើលអត្ថបទ {knowledgeBase} នេះ ដើម្បីស្វែងយល់បន្ថែម។',
    },
    knowledge_base: 'មូលដ្ឋានចំណេះដឹង',
    domains_to_validate: 'ដែន​ត្រូវ​ធ្វើ​ឱ្យ​មាន​សុពលភាព',
    domains: 'ដែន',
    file_to_download: 'ឯកសារដែលត្រូវទាញយក',
    primary: 'បឋមសិក្សា',
    edit_dcv: {
        title: 'កែសម្រួល DCV',
        edit_for: 'កែសម្រួលវិធីសាស្រ្ត DCV សម្រាប់',
        hint: 'វិធីសាស្ត្រកំណត់សុពលភាពនៃការគ្រប់គ្រងដែន (DCV) គឺចាំបាច់សម្រាប់គោលបំណងសុវត្ថិភាព។ អាជ្ញាធរវិញ្ញាបនប័ត្រប្រើប្រាស់ DCV ដើម្បីផ្ទៀងផ្ទាត់ថាបុគ្គលដែលដាក់សំណើនោះជាម្ចាស់ដែន និង/ឬត្រូវបានអនុញ្ញាតឱ្យប្រើវា។ អ្នកអាចឃើញ DCV ជាអ្វី និងរបៀបប្រើវាដោយចុចលើប៊ូតុង "អានបន្ថែម"។',
    },
    resend_mail: {
        modal_title: 'ផ្ញើ​អ៊ី​ម៉ែ​ល​ម្តង​ទៀត',
        title: 'ផ្ញើអ៊ីមែលឡើងវិញសម្រាប់ការត្រួតពិនិត្យដែនសុពលភាព',
        subtitle:
            'សូមស្វែងរកវា ហើយចុចលើតំណភ្ជាប់ដែលបានរួមបញ្ចូល ដើម្បីបញ្ចប់នីតិវិធី DCV របស់អ្នក។ ប្រសិនបើអ្នកមិនទាន់បានទទួលអ៊ីមែលទេ គ្រាន់តែចុចប៊ូតុង RESEND ហើយយើងនឹងផ្ញើវាម្តងទៀត។ វិធីសាស្ត្រ DCV (Domain Control Validation) គឺជាវិធីនៃការបង្ហាញថាអ្នកជាម្ចាស់ ឬគ្រប់គ្រងឈ្មោះដែនដែលបានចុះឈ្មោះជាក់លាក់មួយ។ មើលអត្ថបទ {knowledgeBase} នេះ ដើម្បីស្វែងយល់បន្ថែម។',
    },
    via: 'តាមរយៈ',
    get_record: {
        title: 'ទទួលបានកំណត់ត្រា',
        heading_title: 'ទទួលបានកំណត់ត្រាសម្រាប់ការត្រួតពិនិត្យដែនសុពលភាព',
        main_content:
            'វិធីសាស្រ្ត DCV (Domain Control Validation) គឺជាវិធីនៃការបញ្ជាក់ថាអ្នកជាម្ចាស់ ឬគ្រប់គ្រងឈ្មោះដែនដែលបានចុះឈ្មោះជាក់លាក់មួយ។ ដើម្បីបញ្ចប់នីតិវិធី DCV សូមប្រើព័ត៌មានដែលបានផ្តល់ខាងក្រោមដើម្បីបង្កើតកំណត់ត្រា CNAME សម្រាប់ដែនរបស់អ្នក។',
        content: {
            0: 'ប្រសិនបើអ្នកប្រើ DNS មូលដ្ឋានរបស់ 1Byte៖ ចូលទៅកាន់ទំព័រ host records ដើម្បីបង្កើត CNAME សម្រាប់ដែននីមួយៗដែលត្រូវការពារ។',
            1: 'ប្រសិនបើអ្នកប្រើ DNS 1Byte៖ បង្កើតកំណត់ត្រា CNAME ដោយដៃនៅក្នុងគណនី cPanel របស់អ្នក។',
            2: 'ប្រសិនបើអ្នកប្រើ DNS ផ្សេងទៀត៖ អ្នកនឹងត្រូវបង្កើតកំណត់ត្រា CNAME ដោយដៃនៅឯក្រុមហ៊ុនផ្តល់ DNS របស់អ្នក។',
            3: 'មើលអត្ថបទ {knowledgeBase} នេះ ដើម្បីស្វែងយល់បន្ថែម។',
        },
    },
    host: 'Host',
    target: 'គោលដៅ',
    change_primary_domain: {
        modal_title: 'ការផ្លាស់ប្តូរដែនដំបូង',
        title: 'ឈ្មោះទូទៅនៅក្នុង CSR របស់អ្នកគឺខុសពីអ្វីដែលវិញ្ញាបនបត្រដំបូងបានកំណត់',
        subtitle:
            'ការមាន "{newDomain}" នៅក្នុង CSR នឹងបង្កើតវិញ្ញាបនបត្រ SSL ថ្មី. SSL ដំបូងជាមួយ "{oldDomain}" នឹងត្រូវបានដកហូត ហើយអ្នកនឹងមិនអាចប្រើវាម្តងទៀតបានទេ។',
    },
    confirm_reissue: {
        modal_title: 'ចេញឡើងវិញនូវវិញ្ញាបនបត្រ {name} ',
        content:
            'សូមចំណាំ៖ នៅពេលដែលអ្នកចាប់ផ្តើមដំណើរការនៃការបន្ដឡើងវិញ អ្នកនឹងមិនអាចទាញយកវិញ្ញាបនបត្រចាស់បានទេ។ តើអ្នកចង់បន្ដឡើងវិញម្ដងទៀតដែរទេ?',
    },
};
